import {React,useState} from "react";
import { Swiper, SwiperSlide  } from 'swiper/react';
import i18n from "../../i18n/i18n";


import 'swiper/css';
import './ProductSignatures.css';


const ProductSignatures = (props) =>{

    const signaturesData = (props.signaturesData) ? props.signaturesData : null;
    const small_banners = (signaturesData?.signature_detailed_images_file_hu ? signaturesData?.signature_detailed_images_file_hu.split('|') : null);

    return <>
        {signaturesData ?
        <div className="signatures_cont">
            {signaturesData.signature_detailed_img_file_hu ? <div className="signatures_head_banner"><img src={process.env.REACT_APP_ORIGINAL_SHOP_URL+signaturesData.signature_detailed_img_file_hu} alt=""></img></div>  : ''}
            {signaturesData.signature_details_blob_hu ? <div className="signatures_description" dangerouslySetInnerHTML={{__html: signaturesData.signature_details_blob_hu}}></div> : ''}
            {signaturesData.signature_detailed_images_file_hu ? 
                <Swiper className='signature_slider' slidesPerView={2} spaceBetween={15}>
                    {small_banners.map((banner,index)=>{
                    return <SwiperSlide key={banner} >
                        <img src={process.env.REACT_APP_ORIGINAL_SHOP_URL+'upload_files/collab/detailed/thumbs/thumb_signature_'+banner}></img>
                    </SwiperSlide>
                    })}
                </Swiper>

            : ''}
            <h2>{i18n.t('productDetailsSignatureProductsLabel')}</h2>
        </div> 
         : ''}
    </>;
}

export default ProductSignatures;